import { useEffect, useState } from "react";
import Carousel from "react-material-ui-carousel";
import useHomeBanner from "../../hooks/useHomeBanner";
import { Grid, useTheme } from "@mui/material";
import CouponsSlider from "../../components/Coupons/CouponsSlider";
import HomePageFilters from "../HomePageFilters/HomePageFilters";
import Loader from "../UI/loader/Loader";
import { useGetLocations } from "../../hooks/useGetLocations";
import { useSelector } from "react-redux";
import { RootState } from "../../store/ducks";
import useIsMobile from "../../hooks/useIsMobile";

const HomeBanner = () =>
{
  const theme = useTheme();

  const [errorAlert, setErrorAlert] = useState(false);

  const { fetchDiscounts, textArray } = useHomeBanner(setErrorAlert);

  const selectedLocationStore = useSelector(
    (state: RootState) => state?.store?.selectedLocation
  );

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() =>
  {
    // console.log("locationTexts: ", locationTexts)
    const discountPercentage = JSON.parse(
      localStorage.getItem("discountPercentage") ?? `""`
    );
    if (discountPercentage === "")
    {
      fetchDiscounts();
    }
  }, []);
  const { isMobile } = useIsMobile();

  // const config =
  //   "<style>@media only screen and (min-width: 260px) and (max-width: 740px){h1{font-size: 20px;}h2{font-size: 18px;}h3{font-size: 16px;}h4{font-size: 16px;}h5{font-size: 16px;}h6{font-size: 16px;}p{font-size: 16px;}a{font-size: 16px;}i{font-size: 16px;}span{font-size: 16px;}b{font-size: 16px;}br{height:0px;}}</style>";
  const parseHTML = (htmlString: string) =>
  {
    return htmlString ? (
      <div
        // dangerouslySetInnerHTML={{
        //   __html: isMobile
        //     ? config + " " + htmlString?.replaceAll("<br>", "")
        //     : htmlString,
        // }}
        dangerouslySetInnerHTML={ {
          __html: htmlString,
        } }
      />
    ) : (
      <></>
    );
  };

  // if(locationsLoading) return <Loader/>
  return (
    <section className="banner banner-one" style={ { marginBottom: "3rem" } }>
      <div className="auto-container">
        <Grid container spacing={ 2 }>
          {/* Carousel Section */ }
          <Grid item xl={ 12 } lg={ 12 } md={ 12 } sm={ 12 } xs={ 12 }>
            <div
              className="banner-left-container"
              style={ {
                backgroundImage: selectedLocationStore?.homePageImage
                  ? `url(${selectedLocationStore?.homePageImage})`
                  : `url(${require("../../assets/images/banner/banner-01.jpg")}`,
                backgroundRepeat: "no-repeat",
                backgroundSize: window.innerWidth < 1025 ? "contain" : "cover",
              } }
            >
              {
                isMobile ? (
                  <div className="banner-item">
                    <div className="banner-content" style={ { minHeight: '200px' } }>
                      { parseHTML(textArray?.[2] ?? "") }
                    </div>
                  </div>

                ) : (
                  <Carousel
                    index={ activeIndex }
                    animation="slide"
                    onChange={ (index: any) => setActiveIndex(index) }
                    indicators={ false }
                    navButtonsAlwaysInvisible
                  >
                    { textArray
                      ?.slice(0, 2)
                      .filter((text): text is string => text !== null && text !== undefined && text.trim().length > 0)
                      .map((item, index) => (
                        <div className="banner-item" key={ index }>
                          <div className="banner-content">
                            { parseHTML(item) }
                          </div>
                        </div>
                      )) }
                  </Carousel>
                )
              }

            </div>
          </Grid>
          <Grid
            item
            xl={ 1 }
            lg={ 1 }
            md={ 1 }
            sm={ 1 }
            xs={ 1 }
            sx={ {
              zIndex: "-100",
              [theme.breakpoints.down("xs")]: {
                marginTop: "-120px",
              },
              [theme.breakpoints.down("sm")]: {
                marginTop: "-100px",
              },
              [theme.breakpoints.down("md")]: {
                marginTop: "-120px",
              },
              [theme.breakpoints.up("lg")]: {
                marginTop: "-250px",
              },
            } }
          ></Grid>
          <Grid
            item
            xl={ 10 }
            lg={ 10 }
            md={ 10 }
            sm={ 12 }
            xs={ 12 }
            sx={ {
              zIndex: "1",
              [theme.breakpoints.down("xs")]: {
                marginTop: "-140px",
              },
              [theme.breakpoints.down("sm")]: {
                marginTop: "-120px",
              },
              [theme.breakpoints.down("md")]: {
                marginTop: "-120px",
              },
              [theme.breakpoints.up("lg")]: {
                marginTop: "-250px",
              },
            } }
          >
            <HomePageFilters />
          </Grid>
        </Grid>
      </div>

      <div
        className="auto-container"
        style={ { marginTop: "2rem", padding: "5px" } }
      >
        <CouponsSlider />
      </div>
    </section >
  );
};

export default HomeBanner;
